export const CHANGE_STYLE_BUTTON = 'change-style-button'
export const CREATE_CITATION_BUTTON = 'create-new-cite-btn'
export const COPY_ALL_BUTTON = 'copyAllButton'
export const EXPORT_ALL_BUTTON = 'exportAllButton'
export const SORT_BY_BUTTON = 'sortByButton'
